import { render, staticRenderFns } from "./EditTransactionComponent.vue?vue&type=template&id=dc030c20&"
import script from "./EditTransactionComponent.vue?vue&type=script&lang=js&"
export * from "./EditTransactionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports